<section class="section">
  <header
    (click)="toggleExpanded()"
    (keydown.enter)="toggleExpanded()"
    (keydown.space)="toggleExpanded()"
    [ngClass]="expanded ? 'expanded' : 'collapsed'"
    tabindex="0"
    [title]="[(expanded ? 'Hide ' : 'Show ') + 'Date format for this field']"
    >
    <mat-icon fontIcon="edit_calendar" title="Custom date format"></mat-icon>
    <h3>
      Format date field
      @if (hasChanged) {
        <span class="has-changed-indicator" title="Update field changes below">*</span>
      }
    </h3>
    <mat-icon fontIcon="expand_more" class="expand-icon"></mat-icon>
  </header>
  @if (expanded) {
    <table class="table-full-width" @configSectionsInOut>
      <tr>
        <td><p>Change the date format for this field</p></td>
      </tr>
      <tr>
        <td>
          <span class="input-container">
            <input
              [(ngModel)]="dateFormat"
              placeholder="e.g. dd MM yyyy"
              title="Enter date format, e.g. dd MM yyyy"
              (keydown.escape)="clearDateFormat()"
              (input)="updateParent()"
              />
              <mat-icon
                fontIcon="close"
                class="clear-condition"
                (click)="clearDateFormat()"
                (keydown.enter)="clearDateFormat()"
                (keydown.space)="clearDateFormat()"
                title="Note: Clearing date format will not affect tags previously added to the document"
                tabindex="1"
              ></mat-icon>
            </span>
          </td>
        </tr>
        <tr class="grey">
          <td>
            e.g. dd/MM/yyyy = 03/11/{{ currentYear }} or MMM d[o], yyyy = Nov 3rd,
            {{ currentYear }}
          </td>
        </tr>
        <tr>
          <td><p>Language</p></td>
        </tr>
        <tr>
          <td>
            <span class="input-container">
              <input
                [(ngModel)]="language"
                placeholder="e.g. en-GB"
                title="Enter language, e.g. en-GB"
                (keydown.escape)="clearLanguage()"
                (ngModelChange)="updateParent()"
                />
                <mat-icon
                  fontIcon="close"
                  class="clear-condition"
                  (click)="clearLanguage()"
                  (keydown.enter)="clearLanguage()"
                  (keydown.space)="clearLanguage()"
                  title="Note: Clearing language will not affect tags previously added to the document"
                  tabindex="1"
                ></mat-icon>
              </span>
            </td>
          </tr>
        </table>
      }
    </section>
